import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup,FormArray, Validators} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";

import { from } from 'rxjs';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import { LayoutUtilsService } from 'src/app/core/_base/crud';

import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';

import { Alert } from 'selenium-webdriver';
import { ADM0009ServiceService } from '../../../../Service/ADM0009/adm0009-service.service';
import { Input,  Inject} from '@angular/core';
import { ADM0009Class } from '../../../../Class/ADM0009/adm0009-class';
import { Ba1300Class } from '../../../../Class/ba1300/ba1300-class';
import { Da9000Class } from '../../../../Class/da9000/da9000-class';
import { CommonService } from '../../../../Service/common/common-service.service';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'kt-notification-datails',
  templateUrl: './notification-datails.component.html',
  styleUrls: ['./notification-datails.component.scss']
})
export class NotificationDatailsComponent   implements OnInit,AfterViewInit {


  cdialogResult:any;

  Form:FormGroup;
  closeResult: string;
  MandatoryStatus: string;

  CalenderList:any[];
  PaySlipList:any[];
  FkPerdIdList:any[];
  ValSelect:any;


  lblPageTitle: string = "";
  lblBack: string;
  lblClear: string;
  lblDelete: string;
  lblSave: string;
  lblSave_Exit: string;
  lblSave_Duplicate: string;
  lblSave_Continue: string;
  lblBack_to_Fin_Tool: string;
  lblClear_Changes_Tool: string;
  lblDelete_Selected_Entry_Tool: string;
  lblSave_Exit_Tool: string;
  lblDelMaster_Heading: string;
  lblDelMaster_Message: string;
  lblDelMaster_Progress_Message: string;
  lblDelMaster_Confirmation: string;
  lblDelMaster_Cancel: string;
  lblDelMasterDelete: string;
  lblConfirmTran: string;
  lblUserNam: string;
  lblUserLgnPwd: string;
  lblUserTrnPwd: string;
  lblFkFieldIdUserGroup: string;
  lblFkFieldIdUserType: string;
  lblFkEmpId:string;
  lblExternalUserName:string;
  lblActive:string;
  lblRemarks:string;
  lblValidUpTo:string;
  lblPortalUser:string;
  lblFkRoleId:string;
  lblFkCompId:string;
  lblConfirm:string;
  CtrlNames:any[];
  lblSelect:string;
  lblAdd:string;
  lblDuplication: string;
  lblMandatory: string;
  lblSystemError: string;

  // lblReferenceNo: string  
  lblTitle: string;
  lblMessages: string;
  lblTillDate:string;
  lblSendViaEmail: string;
  lblAttachment: string;
  lblSelectEmployees: string;
  lblSelectEmployeesToolTip: string;
  tblAnnouncementDetailsArray :Array<any>=[];
  empNo: string = '';
  empName: string = '';
  Errors:any[];
  count:number;
  tblNotificatioExpandArray :Array<any>=[];
  private fieldArray: Array<any> = [];
  fieldArrayCount:any[];
attachmentModalVisible = false;
 private fileList: Array<any> = [];
selectedAttachment: any = null;

icoDoc: string;
  icoImg: string;
  icoPdf:string= "UploadFiles/DocManager/Default/pdf.png";
  icoPpt: string;
  icoTxt: string;
  icoUnknown: string;
  icoXls: string;
  icoZip: string;
   photoURL: string;
   signURL:string;
    currentUrl:string;
    attachmentMap: { [notificationId: number]: any[] } = {};


  objDa7420Service: any;
	// dialogRef:any;
  constructor(private objCommonService:CommonService,public dialogRef: MatDialogRef<NotificationDatailsComponent>,private ADM0009service:ADM0009ServiceService,public dialog: MatDialog,private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef,  @Inject(MAT_DIALOG_DATA) public ParamData: any ) {

  }
	ngOnInit() {
     this.currentUrl =  environment.baseUrl.replace("api/", "");
         this.photoURL = "UploadFiles/DocManager/Default/photo.png";
         this.signURL = "UploadFiles/DocManager/Default/sign.jpg";
         this.icoDoc = "UploadFiles/DocManager/Default/doc.png";
         this.icoImg = "UploadFiles/DocManager/Default/img.png";
         this.icoPdf = "UploadFiles/DocManager/Default/pdf.png";
         this.icoPpt = "UploadFiles/DocManager/Default/ppt.png";
         this.icoTxt = "UploadFiles/DocManager/Default/txt.png";
         this.icoUnknown = "UploadFiles/DocManager/Default/unknown.png";
         this.icoXls = "UploadFiles/DocManager/Default/xls.png";
         this.icoZip = "UploadFiles/DocManager/Default/zip.png";
  
    this.Form = this.formBuilder.group({
   
  

    });
  const currentUserString = localStorage.getItem('currentUser');
  const currentUser = currentUserString ? JSON.parse(currentUserString) : null;
  this.empNo = currentUser.EmpNo;
  this.empName = currentUser.UserNam;
    // this.CalenderList = []; 
  
    // this.Errors=[];
    // this.lblSelectEmployees = "Select Employees";
    // this.lblSelectEmployeesToolTip = "Employees Selected";
    // document.getElementById('divSelecedEmployee').hidden = true;

    



  }
	// onClick(field)
	// {	

	// 	this.ADM0009service.LoadDetailDocument(DocType).subscribe(data=>{     
	// 		this.tblNotificatioExpandArray = data.ADM0009DocDetailsList as ADM0009Class[];     
	// 		this.changeDetectorRef.detectChanges();
	// 		})
	
		
	// }
ngAfterViewInit() {
  if (this.ParamData.CategeoryName != null) {
    const objADM0009Class = new ADM0009Class();
    objADM0009Class.CategeoryName = this.ParamData.CategeoryName;
    objADM0009Class.NotificationId = this.ParamData.NotificationId;

    this.ADM0009service.LoadDetailDocument(objADM0009Class).subscribe(data => {
      this.tblNotificatioExpandArray = data.ADM0009DocDetailsList as ADM0009Class[];

      // Fetch attachments for each NotificationId
      this.tblNotificatioExpandArray.forEach(notification => {
        const objDa9000Class = new Da9000Class();
        objDa9000Class.TableName = 'widget0004';
        objDa9000Class.AutoId = notification.NotificationId;

        this.objCommonService.SelectAttachments(objDa9000Class).subscribe(fileData => {
          this.attachmentMap[notification.NotificationId] = fileData;
          this.changeDetectorRef.detectChanges();
        });
      });

      this.changeDetectorRef.detectChanges();
    });
  }
}


  Close()
  {
    
    
    this.dialogRef.close(`${""}`);
  }

  LoadList()
  {

    // this.objWIDGET0004ervice.GetCountAnnouncement().subscribe(list=>{ 
    //   this.fieldArrayCount=list;		

    // // this.objWIDGET0004ervice.GetCountAnnouncement().subscribe(data=>{  
   
    // //   this.tblAnnouncementDetailsArray = data.WIDGET0004List ;    
      
    //   this.changeDetectorRef.detectChanges();
    //   })
  }





 




  
  getComponentTitle() 
  {

		let result = this.lblPageTitle;
		return result;
  }

openAttachmentModal(field: any): void {
  const notificationId = field.NotificationId;

  // Set selected field
  this.selectedAttachment = field;

  // Load from pre-fetched map (if available)
  this.fileList = this.attachmentMap[notificationId] || [];

  // Show modal
  this.attachmentModalVisible = true;
}

closeAttachmentModal() {
  this.attachmentModalVisible = false;
  this.selectedAttachment = null;
}
  OpenFile(file)
  {
    window.open(file);
  }

  removeAttachment(index)
  {
    this.fileList.splice(index, 1);
  }
  prepareCrmReportData(): any[] {
  return (this.tblNotificatioExpandArray || []).map((item, index) => {
    return {
      SlNo: index + 1,
      EmpNo: item.EmpNo,
      EmployeeName: item.EmployeeName || this.empName,
      NotificationContent: this.stripHtml(item.NotificationContent),
      Status: item.ReadFlag == 1 ? 'Read' : 'Unread'
    };
  });
}
stripHtml(html: string): string {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
}

download() {

  if (!this.tblNotificatioExpandArray || this.tblNotificatioExpandArray.length === 0) {
    alert("No data available to export");
    return;
  }

  // const reportData = this.prepareCrmReportData();

  // 🔴 IMPORTANT: backend must accept this


      this.objCommonService.DownloadTaskExcel("crmReportTable", "NotificationReport");

 

}
onPrint() {

  if (!this.tblNotificatioExpandArray || this.tblNotificatioExpandArray.length === 0) {
    alert("No data to print");
    return;
  }

  let html = `
    <html>
      <head>
        <title>Notification Details</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          h2 { text-align: center; margin-bottom: 20px; }

          table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
          }

          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
            vertical-align: top;
          }

          th {
            background-color: #f2f2f2;
          }
        </style>
      </head>
      <body>
        <h2>${this.ParamData.CategeoryName || 'Notification Details'}</h2>

        <table>
          <thead>
            <tr>
              <th>Sl No</th>
              <th>Emp No</th>
              <th>Employee Name</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
  `;

  this.tblNotificatioExpandArray.forEach((item, i) => {
    html += `
      <tr>
        <td>${i + 1}</td>
        <td>${item.EmpNo || ''}</td>
        <td>${item.EmployeeName || this.empName || ''}</td>
        <td>${this.stripHtml(item.NotificationContent || '')}</td>
      </tr>
    `;
  });

  html += `
          </tbody>
        </table>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank', 'width=1200,height=700');

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();

  // IMPORTANT: wait before print
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
}
  }









  



